<div class="row">
  <div class="col-md-12 checkbox d-flex justify-content-end mb-3 mt-4">
    <label>
      <input
        id="selectAllPermissionsReports"
        [(ngModel)]="permissionReport.selectAllPermissionReport.Selected"
        class="cc-filter-checkbox set-pointer-events"
        type="checkbox"
        kendoCheckBox
        [disabled]="
          isUkgDefaultGroup || isViewOnly || !disabledSelectAllReports
        "
        (change)="valueChangeByselectAllPermissionsReport($event)"
      />
      {{ "_Permission_Select_All_Report_Permissions_" | translate }}
    </label>
  </div>
  <ng-container *ngIf="isLoaded">
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Report_Lobby_Activity_Title_Text_" | translate }}
          </h6>
          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="larSAll"
                [(ngModel)]="permissionReport.LobbyActivity.selectAll"
                (change)="selectAllLobbyActivity()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionReport.LobbyActivity.viewLobbyActivity.Enabled ||
                  !permissionReport.LobbyActivity.shareTemplateLobbyActivity
                    .Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="60"
                  name="vLAR"
                  (change)="onLobbyActivityItemChange()"
                  [(ngModel)]="
                    permissionReport.LobbyActivity.viewLobbyActivity.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionReport.LobbyActivity.viewLobbyActivity.Enabled
                  "
                />
                {{
                  permissionReport.LobbyActivity.viewLobbyActivity.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="87"
                    (change)="onLobbyActivityItemChange()"
                    name="stLAR"
                    [(ngModel)]="
                      permissionReport.LobbyActivity.shareTemplateLobbyActivity
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionReport.LobbyActivity.shareTemplateLobbyActivity
                        .Enabled ||
                      !permissionReport.LobbyActivity.viewLobbyActivity.Selected
                    "
                  />
                  {{
                    permissionReport.LobbyActivity.shareTemplateLobbyActivity
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
            <!-- Commented out because editing lobby activity records is not possible yet. -->
            <!-- <div class="tab-indent mt-1">
                        <div class="checkbox">
                            <label>
                                <input id="61" (change)="onLobbyActivityItemChange()" name="
                                eLAR" [(ngModel)]="permissionReport.LobbyActivity.editLobbyActivity.Selected"
                                    class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                                    [disabled]="!permissionReport.LobbyActivity.editLobbyActivity.Enabled || !permissionReport.LobbyActivity.viewLobbyActivity.Selected" />
                                {{permissionReport.LobbyActivity.editLobbyActivity.DisplayName | translate}}
                            </label>
                        </div>
                    </div> -->
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="89"
                    (change)="onLobbyActivityItemChange()"
                    name="dtLAR"
                    [(ngModel)]="
                      permissionReport.LobbyActivity.deleteTemplateLobbyActivity
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionReport.LobbyActivity
                        .deleteTemplateLobbyActivity.Enabled ||
                      !permissionReport.LobbyActivity.viewLobbyActivity.Selected
                    "
                  />
                  {{
                    permissionReport.LobbyActivity.deleteTemplateLobbyActivity
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="91"
                    (change)="onLobbyActivityItemChange()"
                    name="vSIOR"
                    [(ngModel)]="
                      permissionReport.LobbyActivity.viewLobbyActivity
                        .Selected &&
                      permissionReport.LobbyActivity.viewStaffSignInOutReport
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionReport.LobbyActivity.viewStaffSignInOutReport
                        .Enabled ||
                      !permissionReport.LobbyActivity.viewLobbyActivity.Selected
                    "
                  />
                  {{
                    permissionReport.LobbyActivity.viewStaffSignInOutReport
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="permission-group">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="sub-heading mb-1">
            {{ "_Permission_Report_Lobby_Editor_Title_Text_" | translate }}
          </h6>
          <div class="checkbox d-flex justify-content-center">
            <label>
              <input
                id=""
                name="lESA"
                [(ngModel)]="permissionReport.LobbyEdit.selectAll"
                (change)="selectAllLobbyEdit()"
                class="cc-filter-checkbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="
                  !permissionReport.LobbyEdit.viewLobbyEditReports.Enabled ||
                  !permissionReport.LobbyEdit.editLobbyEditReports.Enabled ||
                  !permissionReport.LobbyEdit.shareTemplateLobbyEditReports
                    .Enabled
                "
              />
              {{ "_General_Select_All_Text_" | translate }}
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="checkbox">
              <label>
                <input
                  id="70"
                  name="vedRSelecte"
                  (change)="onLobbyEditItemChange()"
                  [(ngModel)]="
                    permissionReport.LobbyEdit.viewLobbyEditReports.Selected
                  "
                  class="cc-filter-checkbox"
                  type="checkbox"
                  kendoCheckBox
                  [disabled]="
                    !permissionReport.LobbyEdit.viewLobbyEditReports.Enabled
                  "
                />
                {{
                  permissionReport.LobbyEdit.viewLobbyEditReports.DisplayName
                    | translate
                }}
              </label>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="71"
                    (change)="onLobbyEditItemChange()"
                    name="
                                eLeRs"
                    [(ngModel)]="
                      permissionReport.LobbyEdit.editLobbyEditReports.Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionReport.LobbyEdit.editLobbyEditReports
                        .Enabled ||
                      !permissionReport.LobbyEdit.viewLobbyEditReports.Selected
                    "
                  />
                  {{
                    permissionReport.LobbyEdit.editLobbyEditReports.DisplayName
                      | translate
                  }}
                </label>
              </div>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="88"
                    (change)="onLobbyEditItemChange()"
                    name="stLeRs"
                    [(ngModel)]="
                      permissionReport.LobbyEdit.shareTemplateLobbyEditReports
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionReport.LobbyEdit.shareTemplateLobbyEditReports
                        .Enabled ||
                      !permissionReport.LobbyEdit.viewLobbyEditReports.Selected
                    "
                  />
                  {{
                    permissionReport.LobbyEdit.shareTemplateLobbyEditReports
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
            <div class="tab-indent mt-1">
              <div class="checkbox">
                <label>
                  <input
                    id="90"
                    (change)="onLobbyEditItemChange()"
                    name="dtLeRs"
                    [(ngModel)]="
                      permissionReport.LobbyEdit.deleteTemplateLobbyEditReports
                        .Selected
                    "
                    class="cc-filter-checkbox"
                    type="checkbox"
                    kendoCheckBox
                    [disabled]="
                      !permissionReport.LobbyEdit.deleteTemplateLobbyEditReports
                        .Enabled ||
                      !permissionReport.LobbyEdit.viewLobbyEditReports.Selected
                    "
                  />
                  {{
                    permissionReport.LobbyEdit.deleteTemplateLobbyEditReports
                      .DisplayName | translate
                  }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
